var quiz = {
  questions: {
    directed: {
      ab: [{
          question: 'W telewizji najchętniej oglądam...',
          template: 1,
          set: 1,
          answers: [{
              text: 'wiadomości',
              type: 'a',
              number: '1'
            },
            {
              text: 'komedie',
              type: 'b',
              number: '2'
            },
            {
              text: 'programy edukacyjne',
              type: 'a',
              number: '3'
            },
            {
              text: 'kryminały',
              type: 'b',
              number: '4'
            }
          ]
        },
        {
          question: 'W pracy bardziej cenię dobrą atmosferę niż możliwość szybkiego awansu.',
          template: 2,
          set: 2,
          answers: [{
              text: 'Zgadzam się',
              type: 'a'
            },
            {
              text: '',
              type: 'a'
            },
            {
              text: '',
              type: 'b'
            },
            {
              text: 'Nie zgadzam się',
              type: 'b'
            }
          ]
        }
      ],
      ac: [{
          question: 'W podróż dookoła świata wziąłbym...',
          template: 1,
          set: 1,
          answers: [{
              text: 'partnera/-kę',
              type: 'a',
              number: '1'
            },
            {
              text: 'aplikację ze zniżkami',
              type: 'c',
              number: '2'
            },
            {
              text: 'notes, aby zapisywać wspomnienia',
              type: 'a',
              number: '3'
            },
            {
              text: 'oszczędności',
              type: 'c',
              number: '4'
            }
          ]
        },
        {
          question: 'Wolę oszczędzać na przyszłość, niż wydawać pieniądze na codzienne przyjemności.',
          template: 2,
          set: 2,
          answers: [{
              text: 'Zgadzam się',
              type: 'a'
            },
            {
              text: '',
              type: 'a'
            },
            {
              text: '',
              type: 'c'
            },
            {
              text: 'Nie zgadzam się',
              type: 'c'
            }
          ]
        }
      ],
      ad: [{
          question: 'Wolę spędzać czas na łonie natury niż w centrum miasta.',
          template: 2,
          set: 1,
          answers: [{
              text: 'Zgadzam się',
              type: 'a'
            },
            {
              text: '',
              type: 'a'
            },
            {
              text: '',
              type: 'd'
            },
            {
              text: 'Nie zgadzam się',
              type: 'd'
            }
          ]
        },
        {
          question: 'Kupując jedzenie zwykle wybieram produkty...',
          template: 3,
          set: 2,
          answers: [{
              text: 'dobrej jakości',
              type: 'a'
            },
            {
              text: 'w ekologicznym opakowaniu',
              type: 'd'
            },
            {
              text: 'bez konserwantów',
              type: 'd'
            },
            {
              text: 'ze sporządzonej listy zakupów, nie kupuję za dużo',
              type: 'a'
            }
          ]
        }
      ],
      bc: [{
          question: 'U ludzi cenię...',
          template: 1,
          set: 1,
          answers: [{
              text: 'kreatywność',
              type: 'b',
              number: '1'
            },
            {
              text: 'chęć pomocy innym',
              type: 'c',
              number: '2'
            },
            {
              text: 'otwartość',
              type: 'b',
              number: '3'
            },
            {
              text: 'wrażliwość',
              type: 'c',
              number: '4'
            }
          ]
        },
        {
          question: 'Najlepsze pomysły zazwyczaj czerpię...',
          template: 3,
          set: 2,
          answers: [{
              text: 'z rozmów ze znajomymi',
              type: 'b'
            },
            {
              text: 'z artykułów naukowych',
              type: 'c'
            },
            {
              text: 'podczas pracy',
              type: 'c'
            },
            {
              text: 'podczas podróży z bliskimi',
              type: 'b'
            }
          ]
        }
      ],
      bd: [{
          question: 'W wolny weekend...',
          template: 1,
          set: 1,
          answers: [{
              text: 'zdobywam nowe umiejętności',
              type: 'b',
              number: '1'
            },
            {
              text: 'spędzam czas na łonie natury',
              type: 'd',
              number: '2'
            },
            {
              text: 'wychodzę ze znajomymi',
              type: 'b',
              number: '3'
            },
            {
              text: 'wyjeżdżam by poznawać nowe miejsca',
              type: 'd',
              number: '4'
            }
          ]
        },
        {
          question: 'Troska o środowisko jest dla mnie ważniejsza niż poświęcanie czasu na rozwój zawodowy.',
          template: 2,
          set: 2,
          answers: [{
              text: 'Zgadzam się',
              type: 'b'
            },
            {
              text: '',
              type: 'b'
            },
            {
              text: '',
              type: 'd'
            },
            {
              text: 'Nie zgadzam się',
              type: 'd'
            }
          ]
        }
      ],
      cd: [{
          question: 'Określiłbym się jako osobę...',
          template: 3,
          set: 1,
          answers: [{
              text: 'twórczą',
              type: 'c'
            },
            {
              text: 'wyrozumiałą',
              type: 'd'
            },
            {
              text: 'empatyczną',
              type: 'd'
            },
            {
              text: 'sprawczą',
              type: 'c'
            }
          ]
        },
        {
          question: 'Idealny prezent urodzinowy to...',
          template: 3,
          set: 2,
          answers: [{
              text: 'czytnik',
              type: 'c'
            },
            {
              text: 'gra planszowa',
              type: 'd'
            },
            {
              text: 'telefon',
              type: 'd'
            },
            {
              text: 'materiałowa torba',
              type: 'c'
            }
          ]
        }
      ]
    },
    general: [{
        question: 'Podczas wolnego popołudnia...',
        template: 1,
        set: 1,
        answers: [{
            text: 'rozważam nowe inwestycje',
            type: 'a',
            number: '1'
          },
          {
            text: 'myślę nad ciekawym projektem',
            type: 'b',
            number: '2'
          },
          {
            text: 'rozmawiam z przyjaciółmi',
            type: 'c',
            number: '3'
          },
          {
            text: 'dbam o ogród',
            type: 'd',
            number: '4'
          }
        ]
      },
      {
        question: 'Gdybym mógł wybrać miejsce zamieszkania, cechowało by się ono...',
        template: 1,
        set: 2,
        answers: [{
            text: 'nowoczesnym centrum',
            type: 'a',
            number: '1'
          },
          {
            text: 'możliwością rozwoju zawodowego',
            type: 'b',
            number: '2'
          },
          {
            text: 'różnymi wydarzeniami kulturalnymi',
            type: 'c',
            number: '3'
          },
          {
            text: 'ścieżkami rowerowymi',
            type: 'd',
            number: '4'
          }
        ]
      },
      {
        question: 'Gdy myślę o swoim życiu najbardziej zajmują mnie...',
        template: 1,
        set: 3,
        answers: [{
            text: 'pieniądze',
            type: 'a',
            number: '1'
          },
          {
            text: 'praca',
            type: 'b',
            number: '2'
          },
          {
            text: 'relacje z bliskimi',
            type: 'c',
            number: '3'
          },
          {
            text: 'środowisko',
            type: 'd',
            number: '4'
          }
        ]
      }
    ]
  },
  answers: [],
  displayedQuestion: [],
  reset: function () {
    this.answers = [];
    this.displayedQuestion = [];
    return this;
  },
  getResult: function () {
    var self = this;
    var groups = Object.keys(this.questions.directed);
    var allAswered = true;
    groups.forEach(function (group) {
      if (self.answers[group] == undefined) {
        allAswered = false;
      }
    });
    if (!allAswered) {
      return [];
    }
    var hitMatrix = [];
    var answerIndex = Object.keys(this.answers)
    answerIndex.forEach(function (type) {
      if (hitMatrix[self.answers[type]] === undefined) {
        hitMatrix[self.answers[type]] = 0;
      }
      hitMatrix[self.answers[type]]++;
    });
    var maxType = [];
    var maxPoints = 0;
    var hitTypes = Object.keys(hitMatrix);
    hitTypes.forEach(function (type) {
      if (hitMatrix[type] == maxPoints) {
        maxType.push(type);
      } else if (hitMatrix[type] > maxPoints) {
        maxType = [type];
        maxPoints = hitMatrix[type];
      }
    });
    return maxType;
  },
  isResultReady: function () {
    return this.getResult() !== false && this.getResult().length == 1;
  },
  getQuestion: function () {
    var groups = Object.keys(this.questions.directed);
    var self = this;
    var unasweredGroup = null;
    var foundUnaswered = false;
    groups.forEach(function (group) {
      if (!foundUnaswered && self.answers[group] === undefined) {
        unasweredGroup = group;
        foundUnaswered = true;
      }
    });
    if (unasweredGroup) {
      var group = this.questions.directed[unasweredGroup];
      var questionIndex = Math.floor(Math.random() * group.length);
      this.displayedQuestion[unasweredGroup] = questionIndex;
      var question = group[questionIndex];
      question.id = unasweredGroup;
      return question;
    }
    var result = this.getResult();
    if (result.length == 1) {
      return null;
    }
    // if (result.length == 2) {
    //   var groupName = result.sort().join('');
    //   var group = this.questions.directed[groupName];
    //   var displayedIndex = this.displayedQuestion[groupName];
    //   var notAskedQuestions = group.filter(function (question, index) {
    //     return index != displayedIndex;
    //   });
    //   var questionIndex = Math.floor(Math.random() * notAskedQuestions.length);
    //   var question = notAskedQuestions[questionIndex];
    //   question.id = 'general';
    //   return question;
    // }
    if (result.length >= 2) {
      var group = this.questions.general;
      var question = group[Math.floor(Math.random() * group.length)];
      question.answers = question.answers.filter(function (answer) {
        return result.indexOf(answer.type) >= 0;
      });
      question.id = 'general';
      return question;
    }

  },
  setAnswer: function (id, value) {
    var groups = Object.keys(this.questions.directed);
    if (id === 'general' || groups.indexOf(id) >= 0) {
      this.answers[id] = value;
    }
    return this;
  }
};

export default quiz;